export function index(withJobs = true)
{
    return axios.get(route('api.manage.companies.job-channels') + (withJobs ? '?include=jobs' : ''))
        .then(response => response.data);
}

export function store(data)
{
    return axios.post(route('api.manage.companies.job-channels.store'), data)
        .then(response => response.data);
}

export function storeJob(jobId, data)
{
    return axios.post(route('api.manage.jobs.job-channels.store', {jobId}) + '?include=jobs', data)
        .then(response => response.data);
}

export function show(jobChannelId)
{
    return axios.get(route('api.manage.job-channels.show', { jobChannelId }));
}

export function update(jobChannelId, data)
{
    return axios.patch(route('api.manage.job-channels.update', { jobChannelId }) + '?include=jobs', data)
        .then(response => response.data);
}

export function updatePivot(jobChannelId, jobId, data)
{
    return axios.patch(route('api.manage.job-channels.update.pivot', { jobChannelId, jobId }) + '?include=jobs', data)
        .then(response => response.data);
}

export function destroy(jobChannelId)
{
    return axios.delete(route('api.manage.job-channels.destroy', { jobChannelId }));
}
